
import { EngineeringOfficeBillDto} from '@proxy/bills/models'
export interface EngineeringOfficeBill extends EngineeringOfficeBillDto {

}
